<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.warehouseinbound_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update} from "@/api/crmedical/warehouse/warehouseinbound";
    import {mapGetters} from "vuex";

    export default {
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
                option: {
                    height: 'auto',
                    calcHeight: 350,
                    tip: false,
                    border: true,
                    index: true,
                    viewBtn: true,
                    selection: true,
                    column: [
                                                                                    {
                                    label: "主键",
                                    prop: "id",
                                    rules: [{
                                        required: true,
                                        message: "请输入主键",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                                                                    {
                                    label: "项目id",
                                    prop: "projectId",
                                    rules: [{
                                        required: true,
                                        message: "请输入项目id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "仓库id",
                                    prop: "warehouseId",
                                    rules: [{
                                        required: true,
                                        message: "请输入仓库id",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "入库单号",
                                    prop: "inboundNo",
                                    rules: [{
                                        required: true,
                                        message: "请输入入库单号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "入库类型（系统字典warehouse_inbound_type  1.采购入库 2.调拨入库 3.盘点入库）",
                                    prop: "type",
                                    rules: [{
                                        required: true,
                                        message: "请输入入库类型（系统字典warehouse_inbound_type  1.采购入库 2.调拨入库 3.盘点入库）",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "关联单号",
                                    prop: "linkNo",
                                    rules: [{
                                        required: true,
                                        message: "请输入关联单号",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "供应商",
                                    prop: "supplier",
                                    rules: [{
                                        required: true,
                                        message: "请输入供应商",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "入库金额",
                                    prop: "inboundAmount",
                                    rules: [{
                                        required: true,
                                        message: "请输入入库金额",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "备注",
                                    prop: "remark",
                                    rules: [{
                                        required: true,
                                        message: "请输入备注",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "录入人",
                                    prop: "enterUser",
                                    rules: [{
                                        required: true,
                                        message: "请输入录入人",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "录入时间",
                                    prop: "enterTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入录入时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "提交人",
                                    prop: "submitUser",
                                    rules: [{
                                        required: true,
                                        message: "请输入提交人",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "提交时间",
                                    prop: "submitTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入提交时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "取消人",
                                    prop: "cancelUser",
                                    rules: [{
                                        required: true,
                                        message: "请输入取消人",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "取消时间",
                                    prop: "cancelTime",
                                    rules: [{
                                        required: true,
                                        message: "请输入取消时间",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "单据状态（系统字典warehouse_inbound_status 1.待提交 2.已入库 3.已关单）",
                                    prop: "inboundStatus",
                                    rules: [{
                                        required: true,
                                        message: "请输入单据状态（系统字典warehouse_inbound_status 1.待提交 2.已入库 3.已关单）",
                                        trigger: "change"
                                    }]
                                },
                                                                                                                {
                                    label: "版本",
                                    prop: "version",
                                    rules: [{
                                        required: true,
                                        message: "请输入版本",
                                        trigger: "change"
                                    }]
                                },
                                                                        ]
                },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehouseinbound_add, false),
                    viewBtn: this.vaildData(this.permission.warehouseinbound_view, false),
                    delBtn: this.vaildData(this.permission.warehouseinbound_delete, false),
                    editBtn: this.vaildData(this.permission.warehouseinbound_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
        methods: {
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
            searchReset() {
                this.query = {};
                this.onLoad();
            },
            searchChange(params) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                page = page || this.page;
                this.loading = true;
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                });
            }
        }
    };
</script>

<style>
</style>
